/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'fabric.reactions.add': 'Add reaction',
  'fabric.reactions.add.new': 'Add new',
  'fabric.reactions.error.unexpected': 'Reactions are temporarily unavailable',
  'fabric.reactions.loading': 'Loading...',
  'fabric.reactions.more.emojis': 'More emojis',
  'fabric.reactions.other.reacted.users': '{count, plural, one {and one other} other {and {count} others}}',
  'fabric.reactions.reactwithemoji': 'React with {emoji} emoji',
  'fabric.reactions.reactwithemojiandcount':
    '{count, plural, one {# {emoji} emoji} other {# {emoji} emojis}}. React with {emoji} emoji',
  'fabric.reactions.summary': 'View all user reactions',
  'reaction-picker-trigger.add.reaction.message': 'Add a reaction',
  'reactions-reaction.picker-label': 'Add reactions',
  'reactions.dialog.close': 'Close',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Left Navigate',
  'reactions.dialog.reactions.count': '{count, plural, one {# total reaction} other {# total reactions} }',
  'reactions.dialog.right.navigate': 'Right Navigate',
  'reactions.dialog.viewall': 'View all',
  'reactions.dialog.viewall.tooltip': 'View all user reactions',
};
